export default {

    breadcrumbBefore: ['首页', '会员中心'], // 集運權限  和  官網展示 麵包屑

    locale: '简体中文',
    exit: '安全退出',
    hi: '你好,',
    signIn: ['登录', '集运'],
    loginOperations: ['会员登入', '会员登记', '忘记密码'],
    navtop: [
        '网站首页',

        // '多宝放提',
        // '多宝狂淘',
        '绿色集运',
        '常见问题',
        '集运须知',
        '仓库及报价',
        '自取点'
    ],
    footer: {
        first: '公司介绍',
        second: '使用条款及免责声明',
        third: '隐私权保护声明',
        fourth: '集运条款及细则',
        fifth: '多宝网©$ 版权所有',
    },
    aside: { //侧边导航栏   children  子导航栏key
        first: {
            name: '多宝集运',
            children: ['货品认领', '我的订单']
        },
        second: {
            name: '多宝狂淘',
            children: ['我要分享', '我的分享', '淘友留言']
        },
        third: {
            name: '会员中心',
            children: ['账户', '集运地址', '地址薄', '积分', '安全退出','优惠券']
        },
    },

    asideDescription: [{
        tips: {
            phone: '电话必须为8到11位数字',
            content: '描述不少于2个字符',
            category: '类别必填'
        },
        title: '商务合作',
        p: '多宝集运全港设有数十个自取点及流动自取站 ，欢迎网点或临售商合作派送及自取业务。',
        form: [{
            placeholder: '请选择类型',
            label: '类型',
            options: ['商务合作', '优惠提供', '业务投诉']
        }, {
            label: '手机',
            placeholder: '填入电话号码'
        }, {
            label: '描述',
            placeholder: '填写你描述内容。'
        },
        ['提交', '重置']
        ]

    },
    {
        title: '联络我们',
        p: `<article class="strong">客服在线时间(红日休息)</article>
            <div class="flex justify-between">
              <span>星期一至六</span>
              <span>09:30 - 12:30</span>
            </div>
            <div class="text-right">13:30 - 18:30</div>
            <br />
            <article class="text-bold u-m-b-4">地址</article>土瓜湾邮政局 邮箱 87064号`
    },
    {
        title: 'Facebook专页',
        p: []
    }
    ],

    recommend: ['好物推荐', '价钱', '加载中'], // 好物推荐这项 因为后加
    commons: {
        OrderComment: ['评价订单', '请给我们意见，让我们改进服务。', '派送服务', '速度效率', '客服态度', '发送中', '发送', '相片(如有)', '请给派送服务评星', '请给速度效率评星', '请客客服态度评星'],
        MoreInfo: {
            last: '没有更多了',
            loading: '小宝正在努力加载中...',
            more: '点我加载更多',
            noneMessage: '小宝查过了，没有更多了',
        },
        FormButtons: {
            send: '送出',
            reset: '重置'
        },
        unit: { //单位  公用
            ge: '个',
            jian: '件',
            gong: '共'
        },
        input_placeholder: '請輸入',
        select_placeholder: '請選擇',
        no_more: '无数据',
        successfully: '操作成功',
        unsuccessfully: '失败失败'


    },


    //  基础布局完毕
    jiyun: {
        breadcrumb: '货品认领',
        expand: ['该货品有以下子运单号', '一键认领'],

        form: {
            tips: '请输物流公司及运单号码认领货件，货到大陆仓，我们会于办公时间8小时内更新货件资料。',
            buttons: ['提交', '重置'],

            eid: { label: '仓库及物流' },
            enum: { label: '物流单号' },
            repack: {
                label: '去箱服务',
                desc: '（需要收服务费）'
            },
            items: {
                label: '申报名称',
                tables: {
                    title: '请如实申报货品详情',
                    add: '添加',
                    props: {
                        name: {
                            label: '货品名称',
                        },
                        category: {
                            label: '货品类别',
                        },
                        qty: {
                            label: '数量',
                        },
                        unit: {
                            label: '单价',
                        },
                        opera: {
                            label: '操作',
                            delete: '删除'
                        }
                    }
                }
            },
        },
        rules: {
            eid: '请选择卖家发货物流公司',
            enum: '请输入正确的运单号码',
            items: '申报信息不完整'
        },

        form2: {
            label: '你知道吗？即使货品未到仓，都可以预先选取货品安排集运，当货品到齐后，我们就会自动给你发货 ( 仅限自取 )。',
            buttons: ['全部货品', '未入仓', '已入仓', {
                name: '集运给我',
                alert: '请选择需要集运的商品'
            }]

        },
        table: ['物流公司', '运单号码', {
            column: '重量',
            title: ['实重', '尺寸']
        }, '仓库', '操作'],
        operatingGroups: {
            search: {
                pop: '追踪物流信息'
            },
            re_declare: {
                pop: '重新申报'
            },
            delete: {
                pop: '删除货品',
                modal: {
                    title: '小宝说',
                    left: '确认要刪除货品',
                    right: ' 吗?',
                    confirm: '确定',
                    cancel: '取消',
                }
            }
        },

        import: {
            key: '入仓日期',
            default: '未入仓'
        },
        custom: {
            key: '海关申报'
        },
        comment: {
            key: '我的备注',
            placeholder: '备注内容仅自己可见',
            noShelfTips: '此货品经己签收，但由于货量激增，此货品未能安排入库，请耐心等侯，我们会尽快处理。如己入库之货品请尽快集运，以便我们腾出更多仓位，谢谢。'
        },
        request: { // show_ship_limit_notice 方法中 confirm提示
            title: '国内禁运品更新通知',
            content: '中国海关通知，即日起国内集运将以下物品列为禁运品，请大家留意。 <br/>所有经由我司转运的货品，均会百分百经过X光机检查，请所有客户如实申报。 <br/>如发现禁运品或虚报资料，一律会以退件或标示为 禁运 处理，有关安排将不会作出通知及任何赔偿。 <br/>请留意禁运品是由海关定义，货物种类或会有增减，<br/>因此包括但不限于以下产品:<br/>刀剑、弹弓、弓箭、雨伞、旗帜、旗杆、宣传横额、无人机、棍棒、黑色T恤、纯色T恤、金属管、萤光棒、雷射笔、面具、头盔、手套、口罩、眼罩、钢珠、手电筒等等。 <br/>如对购买货物有疑问，请先向客服查询，不便之处，敬请见谅。',
            confirm: {
                confirm: '不再提醒',
                cancel: '取消',
            }
        },
    },


    payment: {
        breadcrumb: '支付订单',
        descs: {
            order: '订单',
            type: '集运方式',
            weight: '重量',
            amount: '金额',
            receiver: '收件人',
            phone: '电话',
            address: '地址'
        },
        section_title: "我们支持以下支付方式",
        waiting_for_code: '稍等片刻，正在生成支付码',
        click_to: '按此跳转到 $1 支付',
        paied_text: '按此完成支付'
    },


    step2: {
        breadcrumb: '选择集运方式',

        uncheck: '请选择一个集运方式',
        notify: {
            title: '温馨提示',
            message: '小宝已帮你选中上一次使用的集运方式，如无更改可直接进入下一步'
        },
        type_list: [{
            id: '',
            title: '所有类型'
        },
        {
            id: 1,
            title: "自取点"
        },
        {
            id: 2,
            title: "自取车"
        },
        {
            id: 3,
            title: "自提柜"
        },
        {
            id: 4,
            title: "派送"
        },
        {
            id: 5,
            title: "国内转寄"
        },
            // {
            // 	id: 6,
            // 	title: "国际转运"
            // }
        ],
        cate_list: ['所有区域', '香港区', '九龙区', '新界区'],
        buttons: ['货品数量', '未入仓', '计费重量'],
        nextButton: '下一步',
        card: ['首', '续每'], //卡片
        tips: {
            warn: '皆因你所选取的货品中，有部分尚未到仓，所以只能选择送往自取点。订单金额以货品到齐后审核为准。',
            info: '当前筛选条件下无可用选项'
        },
        loading: "加载中",


        search: {
            placeholder: '请输入地址关键字,如 土瓜湾',
            label: '搜寻',
            tip: '找不到想要的选项？试试输入关键字搜寻。 ',
            settle_weight: '结算重量'
        },
        auto_forward_tips: '自取车订单限长1.5米、限重10Kg。自动集运订单注意不要超过限制，否则将有机会不能正常付运。 ',
        locker_tips: '自提柜集运每单上限3公斤；尺寸不超过 35x30x45 CM',
        alternative_mode_tips: [
            '请选择备选取货点',
            '如果货品操作后未能满足自提柜投递要求,我们会将你的货品投递到备选取货点',
            '重新选择'
        ],
        cate_all: '所有区域',

        no_keyword: '请输入关键字',
        no_applicable: '不适用',

    },

    step3: {
        breadcrumb: '确认订单',

        pageHeaders: [{
            title: '收货信息',
            subTitle: '变更收件人信息',
            list: ['收件', '地址', '邮编', '按此补齐区号'],
            default: '暂无可用收件地址，按此添加'
        },
        // if ul keys     else table keys
        {
            title: '货品清单',
            if: {
                left: ['运单', '重量'],
                right: [{
                    label: '品名',
                    placeholder: '英文品名'
                },
                {
                    label: '材质',
                    placeholder: '英文材质'
                },
                {
                    label: '货值',
                    placeholder: '内件价值'
                },
                {
                    label: '数量',
                    placeholder: '內件数量'
                }
                ]
            },
            else: {
                labels: ['快递公司', '运单号', '实重', '泡重', '货品资料'],
                widthHover: '尺寸'
            }
        },


        {
            title: '订单详情',
            items: ['订单号', '集运方式', '件数', '计费重量', '备选']
        },


        {
            title: '订单结算',
            key: '使用积分',
            unit: '个',
            labels: ['基础运费', '积分抵扣', '实付金额', '送出订单', '逾期費', '支付方式'],
            warn: '当前订单送出后将生成自动集运集运订单，货品全部到仓后由系统自动审核发出，订单重量及运费以系统审核为准。',
            paymentLabel: {
                cash: '货到付款',
                online: '网上支付'
            }
        },


        {
            title: '注意事项',
            timelines: ['严禁承运违禁品包括冒牌货品及任何侵权物品等，违者一律送官究治，有关户亦会被即时终止。',
                '必需如实申报快递方式及缴付运费，否则不会发货，本公司有权追讨少付之运费及行政费$500元。',
                '本公司对于物品运送的延误或遗失所造成的间接损失或其它非主体性损失不承担任何赔偿责任。',
                '积分兑换现金每次最少使用50分，最多可用200分。多宝网对积分之使用及可兑换金额保留最终裁决权。'
            ]
        }
        ],
        tips: { // javascript 中的提示文字     key 对应的方法
            handleChange: '使用积分兑换金额不能高于本次集运应付金额',
            score_placeholder: {
                before: '共',
                after: '个',
                after2: '个，当前不可使用'
            },
        },
        scoreLabel: '积分',
        contactDialog: {
            title: '提示',
            content: '收件电话缺少区号是否补齐？'
        }
    },

    odrder: {
        breadcrumb: '我的订单',

        // 顶部按钮
        buttons: ['全部订单', '待完成', '待发货', '可取货'],
        card: {
            unit: '件',
            status: ['已取货', '可取货', '待发货', '已发货', '到达香港'],
            steps: ['订单已经创建，请按下一步继续', '订单尚未完成，请确认订单后方可发货',
                '订单尚未付款，请确付款后方可发货', '当前订单货品存在模糊申报，请如实重新申报，以免海关查扣',
                '共'
            ],
            buttons: ['下一步', '确认', '支付运费', '重新申报', '取消',
                '追踪', '评价', '货品', '订单', '已支付待确认'
            ],
            tables: ['时间', '地点和跟踪进度'],
            completed: '待完成',

        },

        tips: {
            delete: {
                title: '小宝说',
                left: '确定要删除订单 #',
                right: ' 吗?',
                confirm: '确定',
                cancel: '取消',
            },
            track: ['货品己离开 [国内物流中心]，正送往 [香港物流中心]',
                '货品己到达 [香港物流中心]，我们会尽快安排派送，派送查询可在多宝官网站 LiveChat',
                '派送员正为你进行派送。派送查询可在多宝官网站 LiveChat',
                '你的货品己成功送达。多谢你使用我们的服务',
                '你的纲品未能成功派送，派送司机会再约时间'
            ],
            trackTitle: '追踪订单 #'
        }
    },

    detail: {
        breadcrumb: '订单详情页',
        myComment: ['我的评价', '派送服务', '速度效率', '客服素质', '按此评价订单'], // detail里面加的
        pageHeaders: [{
            title: '收货信息',
            labels: ['收件', '地址', '邮编']
        }, {
            title: '订单详情',
            column: ['订单号', '集运方式', '取货密码', '件数', '计费重量',
                '交易编号', '使用积分', '实付金额', '送出日期', '发货日期', '物流单号'
            ]
        }, {
            title: '货品清单',
            column: ['快递公司', '运单号', '实重', '泡重', '货品资料']
        }],
        buttons: ['下一步', '确认订单', '支付运费',
            '取消', '打印', '已支付待确认'
        ],
        hover: '尺寸',
        invoice: ['多宝网', '新界葵青葵涌永基路55号嘉里货运中心16楼', '收据号', '正式收据']
    },



    memberCenter: { //
        userDetail: {
            breadcrumb: '个人资料',

            pageHeaders: [{
                title: '集运地址',
                labels: ['收件人', '收件电话', '邮政编码', '收件地址']
            },
            {
                title: '我的帐户',
                subTitle: '修改个人资料',
                labels: [
                    '帐户', '淘宝帐户', '昵称', '电话', '可用积分', '专属用户码'
                ]
            },
            ],
            dialog: {
                title: '修改个人资料',
                formItems: [
                    '昵称', '淘宝帐户', '电话', '旧密码', '新密码', '确认新密码'
                ],
                send: '送出'
            },

        },
        exchangeCode: {
            breadcrumb: '积分兑换',

            headerBox: ['每个积分兑换码只可使用一次。 ', '最终解释权归多宝网所有。 '],
            curPoints: '当前积分',
            secondItem: {
                label: '兑换码',
                placeholder: '请输入8位兑换码'
            },
            scoreListTitle: '积分明细',
            scoreListTips: '仅显示2020年10月28日之后的数据',
            table: {
                name: '项目描述',
                points: '积分',
                date: '日期'
            }

        }
    },


    login: {
        breadcrumb: '会员登陆',
        left: {
            title: '会员登入',
            items: [{
                label: '电邮',
                placeholder: '登入帐号'
            },
            {
                label: '密码',
                placeholder: '登入密码'
            }
            ],
            button: '登入',
            validateUsername: '用户名不能小于5位',
            validatePassword: '密码不能小于5位'
        },
        right: {
            title: '还未成为会员',
            items: ['只要填写简单资料', '即可注册成为会员使用服务'],
            button: '成为会员'
        }
    },
    404: {
        list: ['版权所有', '多宝集运', '请检查您输入的网址是否正确或者返回首页', '返回首页'],
        message: '小宝说这个页面你不能进......'
    },
    declare: {
        breadcrumb: '重新申报货品资料',
        title: '新重申报',
        headerBox: '应海关要求，货品名称需如实申报，否则可能会被查扣。 ',
        button: '送出',
        valid_tip: '申报数据不全'
    },
    declare_oversea: {
        // 上面一样就取 declare 的
        title: '请如实申报货品详情',
        add: '添加',
        tables: {
            name: '货品名称',
            category: '货品类型',
            qty: '数量',
            unit: '单价',
            oper: '操作',
            del: '删除'
        },
        submit: '重新申报'
    },

    components: {
        order: {
            // 地址管理
            manage: {
                tip: '请选择收货仓及输入货品重量，即可计算集运收费。 ',
                keyword: '请输入搜索关键字',
                add: '新增地址',
                back: '返回订单',
                delTips: '确定要删除当前地址？ '
            },
            template_address: {
                title: '请填写退件地址',
                gap_tips: [
                    '请正确填写国内退件地址及电话',
                    '此为临时地址，小宝不会存储到地址簿'
                ]
            },
            address_manage: {
                section: '地址薄',
                gap_tips: [
                    '请填写正确的收货地址',
                    '如果是新增电话，小宝会要求SMS验证，以确保可以正确派送'
                ],
            },

            phone_manage: {
                section: '电话薄',
                gap_tips: [
                    '如果是新增电话，小宝会要求SMS验证，以确保能收到取货码',
                ]
            },
            // 地址form
            form: {
                title: '收件人',

                name: '收件人名称',
                phone: '手提电话',
                verify_code: '验证码',
                addressPrefix: '地区',
                address: '详细地址',
                is_default: '设为默认',

                button: '确定'
            },
            // 地址的table
            table: {
                disable_tips: '该地址不支持派送',
                def: '是否默认',
                phone: '名称/电话',
                address: '地址',
                operate: '操作',
                del: '删除',
                update: '修改'
            }

        },
        public: {
            manyboVerifyCode: {
                sendMsg: '发送验证码',
                sendingMsg: '发送中',
                sentMsg: '倒计时'
            }
        }
    },

    home: {
        news: '最新消息',
        contact_us: '联络我们',
        online_cs: '线上客服',
        business_hours: '自取点营业时间',
        facebook: 'FACEBOOK 粉丝专页',
        partner: "合作伙伴",


    },
    warehouse: {
        breadcrumb: '仓库及报价',
    },
    hk: {
        breadcrumb: '运费估算',
        title: '集运计算器',
        tips: [
            '请选择收货仓及输入货品重量，即可计算集运收费。',
            '体积重用于计算低密度的包裹，计出来的重量，会与实重比较，取较重者计算运费。',
            '以下报价以最平的运输方法计算，价钱谨作参考'
        ],


        form: {
            warehouse: {
                label: '收货仓',
                placeholder: '选择收货仓'
            },
            weight: {
                label: '重量',
                placeholder: '请输入重量'
            },
            repack: {
                label: '需去箱包裹数',
                placeholder: '请输入需要拆包得数量'
            },
            volume: {
                label: '体积',
                length: '请输入长度',
                wide: '請輸入寬度',
                height: '请输入高度',
            },
            button: '立即估算'
        },
        search: {
            placeholder: '请输入地址关键字,如 土瓜湾',
            label: '搜寻',
            tip: '找不到想要得选项？ 试试关键字搜寻',
            settle_weight: '结算重量'
        },
        empty: '搜不到内容哦~',
        no_keyword: '请输入关键字',
        rules: {
            wh_id: '请选择收货仓',
            volume: '请补全尺寸',
            weight: '请输入重量',
        },

    },

    faq: {
        breadcrumb: '常见问题'
    },
    contact: {
        breadcrumb: '自取点',
        search: {
            placeholder: '请输入地址关键字,如 土瓜湾',
            label: '搜寻',
            tip: '找不到想要得选项？ 试试关键字搜寻',
            settle_weight: '结算重量'
        },
        no_keyword: '请输入关键字',
        no_more: '沒有更多數據了',
        type_list: [{
            id: '',
            title: '所有类型'
        },
        {
            id: 1,
            title: "自取点"
        },
        {
            id: 2,
            title: "自取车"
        },
        {
            id: 3,
            title: "自提柜"
        }
        ],

    },
    activation: {
        breadcrumb: '帐号激活',
        tips: [
            '点击此处', '重新发送一封启动邮件',
            '邮件发送提醒', '邮件已成功发送到你的邮箱，请及时进行帐号启动。 '
        ]
    },
    forget: {
        breadcrumb: '忘记密码',
        form: [{
            placeholder: '请输入你登记时的电邮',
            label: '电邮',
            btn: '验证码',
            pop: '请输入正确的邮箱格式',
            tip: '请输入你登记时的电邮(5分钟有效)'
        }, {
            placeholder: '请填入验证码',
            label: '验证码',
            pop: '请输入有效验证码（6位）',
            tip: '请输入有效验证码'
        }, {
            placeholder: '请填写登入密码',
            label: '重置密码',
            pop: '密码为6-16个字符',
            tip: '请设定你的新密码'
        }, {
            placeholder: '请填写确认密码',
            label: '确认密码',
            pop: '请和上面密码保持一致',
            tip: '请再输一次密码'
        }],
        buttons: ['发送', '重置']
    },

    register: {
        breadcrumb: '会员登记',
        dialog: ['承运契约条款', '同意', '不同意'],
        finish: ['欢迎登记成为多宝会员。 ',
            '登入电邮激活帐户，即可享受多宝集运的优质服务。 ',
            '按此直接到登入',
            '秒后自动跳转到登入页'
        ],
        form: [{
            placeholder: '请填写电子邮件',
            label: '电邮',
            pop: '请输入正确的邮箱格式',
            tip: '电邮将作为登陆帐户，请正确填写'
        }, {
            placeholder: '请填写淘宝昵称',
            label: '淘宝昵称',
            pop: '淘宝昵称(3-30)个字符',
            tip: '请输入淘宝昵称(非电邮)'
        }, {
            placeholder: '请填入你的电话',
            prefix: {
                options: [
                    "中国大陆",
                    "香港",
                    "澳门",
                    "马来西亚",
                    "美国",
                    "新加坡",
                    "印尼",
                    "泰国",
                    "菲律宾",
                    "日本",
                    "新西兰",
                    "澳洲",
                    "加拿大"
                ],
                placeholder: '地区',
                pop: '请选择区号'
            },
            pop: '填写常用号码(8-11)个字符',
            tip: '选择区号和请填写常用号码'
        }, {
            placeholder: '请填写昵称',
            label: '昵称',
            pop: '昵称4-20个字符',
            tip: '请填写你的昵称'
        }, {
            placeholder: '请填写登入密码',
            label: '登入密码',
            pop: '密码为6-16个字符',
            tip: '请设置你的密码'
        }, {
            placeholder: '请填写确认密码',
            label: '确认密码',
            pop: '请和上面密码保持一致',
            tip: '请再输一次密码'
        }, {
            title: '积分兑换（可选项）',
            tip: '此处可以出入积分兑换码，注册成功后即可获赠对应积分',
            label: '兑换码',
            placeholder: '请输入积分兑换码'
        }, {
            checkBox: ['我已阅读并同意', '承运契约条款'],
            buttons: ['发送', '重置']
        }]
    },


    article: {
        _id: {
            publishTime: '发布时间'
        },

        process: {
            breadcrumb: '集运流程',
            steps: [{
                title: '1.网购',
                step: [
                    '你可在不同的网站购物，用我们国内的地址作为收货地址.',
                    '地址 : 广东省 东莞市 常平镇 袁山贝小龙路8号 多宝网',
                    '收件人: 你的姓名',
                    '电话 : 18680488481',
                    '邮编 : 523583'
                ]
            },
            {
                title: '2.货品认领',
                step: '输入卖家发货的快递公司及单号去认领货品.'
            },
            {
                title: '3.集运香港',
                step: '货品到齐后，选取你要集运的货品，跟据指示选择集运方式、输入地址、电话等资料，付款后(或货到付款)就会马上发货去香港'
            }
            ]
        }
    },
    indication: {
        jiyun: {
            first: '按此进入集运系统',
            formIntro: [
                "按此选择卖家发货的物流公司（ 无则选其他 ）",
                "这里输入卖家发货的物流单号",
                "这里具体准确的输入货品名称，我们将会用于海关申报",
                "然后按这里送出就认领完成了",
                "之后选取需要集运的货品，按这里就可以下单了"
            ],
            navIntro: [
                "认领货品及货品清单由此进入",
                "这里可以查看三个月内的所有订单信息",
                "这里可以把自已买的宝贝分享给淘友，并且经多宝审核可获积分奖励（ 积分可用于抵扣运费 ）",
                "这里可以看到我分享的全部宝贝",
                "这里可以回复淘友的留言",
                "这里可以查看集运地址及修改帐户资料",
                "这里可以看到帐户的可用积分，也可以兑换获得的积分兑换码",
                "如果你使用的不是私人电脑，用完之后记得按此退出系统"
            ]
        }
    },






}